// Route-owned static titles prevent a previous page or reused view from leaking its title.
const pageTitles = Object.freeze({
  Login: 'Log in or sign up',
  TeamLogin: 'Team login',
  AuthAction: 'Account verification and recovery',
  VerifyEmail: 'Verify your email',
  PortalContinue: 'Continue to your account',
  AccountValidation: 'Checking your account',
  Pricing: 'Plans and pricing',
  PurchasePowerhouse: 'Powerhouse checkout',
  PowerhousePurchaseSuccess: 'Powerhouse purchase confirmation',
  ShadowActivation: 'Activate Shadow',
  Apply: 'Business setup',
  Dashboard: 'Dashboard',
  Settings: 'Settings',
  Documentation: 'Documentation',
  DashboardDocumentation: 'Documentation',
  Affiliates: 'Affiliate program',
  PrivacyPolicy: 'Privacy Policy',
  TOS: 'Terms of Service',
  CookiePolicy: 'Cookie Policy',
  DataProcessingAgreement: 'Data Processing Agreement',
  DataAnonymizationPolicy: 'Data Anonymization Policy',
});

export function routePageTitle(route) {
  // Existing brand routes retain their metadata and dynamic brand-detail title.
  if (typeof route?.meta?.title === 'string' && route.meta.title.trim()) return route.meta.title;
  const page = pageTitles[route?.name];
  return page ? `${page} | Tint Bolt` : 'Tint Bolt | Window tint business OS';
}

export function applyRoutePageTitle(route, failure, doc = typeof document === 'undefined' ? null : document) {
  // Aborted, duplicated or superseded navigation must not overwrite the active page.
  if (failure || !doc) return false;
  doc.title = routePageTitle(route);
  return true;
}
